// Components
import { Badge, Td, Tr } from "@chakra-ui/react"
import { Pressable, Profile, Table, Tag } from "components"
import { Mask } from "config"

// Config
import { Moment } from "config"

// Hooks
import { useOrder } from "hooks"

export default function History({ data }){

    const order = useOrder(data?.id)

    const columns = [{ children: '', isNumeric: true }, { children: '' }, { children: '' }]

    return <Table columns={columns}> { order.data?.history?.map(item => <Item key={item.id} data={item} />) }</Table>
}

const Item = ({ data, ...props }) => (
    <Tr {...props}>
        <Td isNumeric children={Mask.dateTime(data?.created_at)} fontSize="small" />
        <Td><Tag children={data?.label} /></Td>
        <Td>{ data?.employee ? <Profile name={data?.employee?.name} src={data?.employee?.avatar_url} /> : <Badge children="Sistema" />}</Td>
    </Tr>
)